// Generic variant:update text sync.
//
// On the main PDP, variant-picker.js fetches the FULL product page and
// dispatches VariantUpdateEvent with detail.data.html = the parsed Document.
// For every [data-gg-sync-scope] matching the updated product, this copies
// textContent + hidden from the counterpart [data-gg-sync] nodes in that
// fresh server HTML — no extra request, no client-side recompute.
//
// [data-gg-sync] nodes must contain text only (textContent assignment
// flattens children). Wrappers with styled children use [data-gg-sync-hidden]
// instead, which mirrors only the hidden flag.
//
// Safe no-op when the fetched HTML lacks the scopes (e.g. quick-add modal
// section renders) — querySelector simply returns null.
document.addEventListener('variant:update', (event) => {
  const data = event.detail?.data;
  if (!data?.html) return;

  document.querySelectorAll('[data-gg-sync-scope]').forEach((scope) => {
    // Combined listings: the variant switch may load a new product.
    if (data.newProduct) scope.dataset.productId = String(data.newProduct.id);
    if (String(data.productId) !== String(scope.dataset.productId)) return;

    // Query the whole fetched document per node (sync keys are unique across
    // scopes) — a scope-first lookup would always resolve to the FIRST scope
    // with this product id and miss keys living in a later one (gg-buy-meta).
    const prefix = `[data-gg-sync-scope][data-product-id="${scope.dataset.productId}"]`;

    scope.querySelectorAll('[data-gg-sync]').forEach((node) => {
      const next = data.html.querySelector(`${prefix} [data-gg-sync="${node.dataset.ggSync}"]`);
      if (!next) return;
      node.textContent = next.textContent;
      node.hidden = next.hidden;
    });

    scope.querySelectorAll('[data-gg-sync-hidden]').forEach((node) => {
      const next = data.html.querySelector(
        `${prefix} [data-gg-sync-hidden="${node.dataset.ggSyncHidden}"]`
      );
      if (next) node.hidden = next.hidden;
    });
  });
});
